import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const Icon3dBoxTop: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="3d-box-top, shaders, model, cube, ar"><path d="M11.9998 1.75L20.8766 6.875V17.125L11.9998 22.25L3.12305 17.125V6.875L11.9998 1.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M20.8766 6.875L11.9998 12M11.9998 22.25V12M3.12305 6.875L11.9998 12" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default Icon3dBoxTop;
